import './App.css';
import { get } from '@aws-amplify/api';
import awsconfig from './aws-exports';
import React, { useEffect, useState, useContext, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { useActiveButton } from './ActiveButtonContext';
import AppLayout from './components/AppLayout';

const myAPI = "api30769188"
const path = '/customers';

const Reports = ({signOut}) => {
  const [input, setInput] = useState("");
  const [customers, setCustomers] = useState([]);
  const { activeButton, setActiveButton } = useActiveButton();

  const navigate = useNavigate();

  useEffect(()=>{
    if (input) {
      navigate(input);
    }
  },[input, activeButton, navigate])

//changed titles
  //Function to fetch from our backend and update customers array
  function getCustomer(e) {
    let customerId = e.input
    get(myAPI, path + "/" + customerId)
       .then(response => {
         console.log(response)
         let newCustomers = [...customers]
         newCustomers.push(response)
         setCustomers(newCustomers)

       })
       .catch(error => {
         console.log(error)
       })
  }

  return (
    <AppLayout signOut={signOut}>
      <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
        {/* Page Title */}
        <div style={{ marginBottom: '32px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: '700', color: 'rgba(0, 0, 0, 0.9)', marginBottom: '8px' }}>
            Reports
          </h1>
          <p style={{ fontSize: '14px', color: 'rgba(107, 114, 128, 1)' }}>
            View performance metrics and analytics
          </p>
        </div>

        {/* Report Cards Grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '24px' }}>
          {/* Iron Condor Performance Card */}
          <div
            onClick={() => setInput("/icPerformance")}
            style={{
              background: 'white',
              borderRadius: '12px',
              border: '1px solid rgba(229, 231, 235, 1)',
              padding: '24px',
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(59, 130, 246, 0.2)';
              e.currentTarget.style.borderColor = 'rgba(59, 130, 246, 0.5)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
              e.currentTarget.style.borderColor = 'rgba(229, 231, 235, 1)';
            }}
          >
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '8px',
              background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '16px'
            }}>
              <span style={{ fontSize: '24px', color: 'white' }}>📊</span>
            </div>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: 'rgba(0, 0, 0, 0.9)',
              marginBottom: '8px'
            }}>
              Iron Condor Performance
            </h3>
            <p style={{
              fontSize: '14px',
              color: 'rgba(107, 114, 128, 1)',
              lineHeight: '1.5',
              margin: 0
            }}>
              View YTD, annualized, and lifetime profit metrics for your Iron Condor strategies
            </p>
          </div>
        </div>
      </div>
    </AppLayout>
  )
}

export default Reports;